import { Layout, Row, Col, Card, Select, Button } from 'antd'; // Import's Ant Design 
import React, { useState, useEffect } from 'react'; // Import's React 
import { useHistory } from 'react-router-dom'; // Import's React Router Dom
import MonthBarChart from './charts/MonthBarChart'; // Import BarChart

const { Content, Header } = Layout // Destructuring Layout

const MonthStatistics = (props) => {

    const navigate = useHistory();
    const group = props.location.params; // Grupo a trabajar
    let title = "";

    switch (group) {
        case 'honda_tijuana':
            title = "Honda Tijuana";
            break;

        case 'honda_mexicali':
            title = "Honda Mexicali";
            break;

        case 'honda_ensenada':
            title = "Honda Ensenada";
            break;

        case 'kia_tijuana':
            title = "Kia Tijuana";
            break;

        case 'kia_mexicali':
            title = "Kia Mexicali";
            break;

        case 'kia_ensenada':
            title = "Kia Ensenada";
            break;

        default:
            const path = { pathname: '/test_chart/YearStatistics' }
            navigate.push(path);
            break;
    }

    return (
        <Content>
            {/* Header */}
            <Header
                style={{ background: 'white', width: '100%', borderRadius: '5px', marginBottom: '1.5rem', boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)' }}>
                <div
                    style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '5px' }}>
                    <div
                        style={{ width: '20%', textAlign: 'start' }}>
                        <a href='/#/test_chart/YearStatistics'>Regresar</a>
                    </div>
                    <div
                        style={{ width: '20%', textAlign: 'center' }}>
                        <h3>{title}</h3>
                    </div>
                    {/* Header Año | Mes */}
                    <div
                        style={{ width: '20%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px' }}>
                        <Button
                            type='primary'>Año
                        </Button>
                        <Button
                            type='primary'>Mes
                        </Button>
                    </div>
                    {/* Header Año */}
                    <div
                        style={{ width: '20%', textAlign: 'center' }}>
                        Agosto 2022
                    </div>
                </div>
            </Header>

            {/* Graphics */}
            <Row>
                <Col
                    span={16}
                    style={{ borderRadius: '5px', margin: '0 auto' }}>
                    <Card
                        size="small"
                        title=""
                        style={{
                            width: '100%',
                            boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)'
                        }}
                    >
                        <MonthBarChart
                            group={group}
                        />
                    </Card>
                </Col>
            </Row>
        </Content>
    )
}

export default MonthStatistics